import { styled } from "@mui/styles";
import { Button, ButtonProps } from "@mui/material";
import { forwardRef } from "react";

const PrimaryUnderlineBtn = styled(Button)(() => ({
    color: "#6B439D !important",
    textDecoration: "#6B439D underline !important",
    "&:hover": {
        backgroundColor: "transparent !important",
    },
}));

const IotVisionUnderlineButton = forwardRef<HTMLButtonElement | null, ButtonProps>(({ disabled, ...props }, ref) => {
    return (
        <PrimaryUnderlineBtn
            disableRipple
            variant="text"
            ref={ref}
            sx={{
                textTransform: "capitalize",
                opacity: disabled ? 0.5 : 1,
            }}
            disabled={disabled}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
        >
            {props.children}
        </PrimaryUnderlineBtn>
    );
});

export default IotVisionUnderlineButton;
